import Styles from './AIRequestDrawer.module.scss'
import { EditorView } from 'prosemirror-view'
import { RetryIconButton } from 'components/AIRevision/RetryIconButton'
import { usePollRevision } from 'hooks/queries/layers/revisions/usePollRevision'

interface Props {
  articleId: string
  layerId: string
  revisionId: string
  view: EditorView
}

export const RetryButton = ({ articleId, layerId, revisionId, view }: Props) => {
  const { data, isLoading } = usePollRevision({ articleId, layerId, id: revisionId })

  if (isLoading || !data?.revision) {
    return null
  }

  const revision = data.revision

  return (
    <div className={Styles.retry}>
      <RetryIconButton revision={revision} view={view} />
    </div>
  )
}
